import React from 'react';
import { Outlet } from 'react-router-dom';

/**
 * PageLayout provides a consistent max-width, centering, and padding for all standard pages.
 * All page content will be rendered inside this container via <Outlet />.
 */
const PageLayout: React.FC = () => (
  <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
    <Outlet />
  </div>
);

export default PageLayout;
